module.exports = __webpack_public_path__ + "img/3.1e4695a1.png";